import { Button, Space,Result } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Renders the page not found component in case of invalid url.
 *
 * @return {ReactElement} The rendered page not found component.
 */
const PageNotFound: React.FC = ({ error,resetErrorBoundary }:any) => {
  const navigate = useNavigate();
  return (
    <section className="section pagenotfound__section">
      <Result status={500} title="Something went wrong!"/>
      <p className="notFoundText">
        <strong>ERROR:</strong> {error.message}
      </p>
      <Space size="large" className="mt-30">
        <Button size="large" type="primary" onClick={() => resetErrorBoundary()}>
          Try Again
        </Button>
      </Space>
    </section>
  );
}

export default PageNotFound;
